<template>
	<Player />
</template>

<script>
	import Player from './components/Player.vue';

	export default {
		name: 'App',
		components: {
			Player,
		},
	};
</script>

<style></style>
